import { render, staticRenderFns } from "./DeclinedPaymentReceipt.vue?vue&type=template&id=42ea3a9a"
import script from "./DeclinedPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./DeclinedPaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./DeclinedPaymentReceipt.vue?vue&type=style&index=0&id=42ea3a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports